export const azul = '#14B0BF'
export const azul_hover = '#0b8a95'
export const laranja = '#FDC00F'
export const itemHover = '#e7e7e7'
export const gray = '#999999'
export const error = '#eb3681'
export const verde = '#3ac2bb'
export const verde_hover = '#34aea8'
export const vinho = '#8B0000'
export const black = '#000'
export const pink = '#ee7387'
export const azul_escuro = '#1240AB'
export const azul_claro = '#1ff6ee'
export const vermelho = '#FF0000'
export const vermelho_hover = '#ff3232'
export const violeta = '#ee82ee'
export const verde_success = '#6aa84f'
export const roxo = '#800080'
export const verde_escuro = '#008000'
